import { render, staticRenderFns } from "./Settle.vue?vue&type=template&id=18940928&scoped=true&"
import script from "./Settle.vue?vue&type=script&lang=js&"
export * from "./Settle.vue?vue&type=script&lang=js&"
import style0 from "./Settle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Settle.vue?vue&type=style&index=1&id=18940928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18940928",
  null
  
)

export default component.exports